import { Box } from "@mui/material";
import { RestaurantOutlined as FallbackIcon } from "@mui/icons-material";
import type { ElementType } from "react";
import { v2 } from "./v2Tokens";
import { imageUrl } from "../../../../utils/imageUrl";

type Props = {
  src?: string | null;
  size?: number;
  icon?: ElementType;
};

/**
 * The image slot for a food or a supplement in a list.
 *
 * Supplements have real images (`AdminSupplement.imageUrl`). Foods do NOT — nothing in
 * the food API carries one — so they fall back to the icon until the food restructure
 * adds the field. The slot is rendered either way so the row layout doesn't jump around
 * once images start arriving.
 */
const Thumb = ({ src, size = 32, icon: Icon = FallbackIcon }: Props) => {
  const resolved = src ? imageUrl(src, size) || src : null;

  return (
    <Box
      sx={{
        width: `${size}px`,
        height: `${size}px`,
        flexShrink: 0,
        borderRadius: v2.rSm,
        border: `1px solid ${v2.line}`,
        background: v2.canvas,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {resolved ? (
        <Box
          component="img"
          data-testid="thumb-image"
          src={resolved}
          alt=""
          sx={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : (
        <Icon sx={{ fontSize: size * 0.5, color: v2.ink3, opacity: 0.6 }} />
      )}
    </Box>
  );
};

export default Thumb;
